
import Vue from 'vue';
import { mapMutations, mapState } from 'vuex';
import Modal from '~/components/common/Modal/Modal.vue';
import WarningIcon from '~/components/partials/public-portfolio/assets/warning.vue.svg';
import CloseIcon from '~/assets/svg/close.vue.svg';

export default Vue.extend({
  name: 'PublicPortfolioLInkedinErrorModal',
  components: { Modal, WarningIcon, CloseIcon },
  computed: {
    ...mapState('portfolio', ['linkedInImportRetriesCount']),
  },
  methods: {
    ...mapMutations('portfolio', ['incrementLinkedInRetriesCount']),
    onTryAgain() {
      this.$analytics.logEvent('public-portfolio__onboarding__linkedin-error-modal', {
        to: 'try-again',
      });
      this.incrementLinkedInRetriesCount();
      this.$router.push(`?dynamic_modal=${this.$constants.dynamicModals.PUBLIC_PORTFOLIO_LINKEDIN_IMPORT_MODAL}`);
    },
    onCancel() {
      this.$analytics.logEvent('public-portfolio__onboarding__linkedin-error-modal', {
        to: 'cancel-importing',
      });
      this.$modal.hide(this.$constants.dynamicModals.PUBLIC_PORTFOLIO_LINKEDIN_ERROR_MODAL);
    },
  },
});
